export default {
  namespaced: true,
  
  state: {
    message: "",
  },

  mutations: {
    setErrorMessage(state, message) {
      if (!state.message) {
        state.message = message;
      }
    }
  },

  getters: {
    isError: (state) => !!state.message,
    errorMessage: state => state.message || 'unknown error',
  }
}